import { useEffect, useContext } from 'react'
//Context
import { I18nContext } from '../context/I18nProvider'

const useSetI18nProviderInformation = (component, params) => {
    const { setActualComponent, setParam, language } = useContext(I18nContext)

    useEffect(() => {
        setActualComponent(component)
        params && setParam(params)

        return () => {
            setParam(null)
        }
    }, [language])
}

export default useSetI18nProviderInformation
